import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { AnalyticLogLabels, APP_REGEX } from '@app/shared';
import { AnalyticService } from '../analytic.service';
interface SanitizedError {
  message: string;
  details: string[];
}
@Injectable()
export class AppErrorHandler implements ErrorHandler {

  constructor(private readonly _analytics: AnalyticService) {}
  
  handleError(error: any): void {
    console.error(error);
    if (error.message.includes(APP_REGEX.LOADING_CHUNK_ERR)) {
      let errorData = this.sanitiseError(error);
      this._analytics.logAnalyticEvent(
          AnalyticLogLabels.ServerError,
          {
              'api_url': location?.href?.toString(),
              'api_request_method': APP_REGEX.LOADING_CHUNK_ERR,
              'api_error_message': JSON.stringify(errorData),
          });
      window.location.reload();
    }
  }

  private sanitiseError(error: Error | HttpErrorResponse): SanitizedError {
    const sanitisedError: SanitizedError = {
      message: error.message,
      details: []
    };
    if (error instanceof Error) {
      sanitisedError.details.push(error.stack ?? '');
    } else if (error instanceof HttpErrorResponse) {
      let erroObj: any = {...error};
      sanitisedError.details = Object.keys(erroObj)
        .map((key: string) => `${key}: ${erroObj[key]}`);
    } else {
      sanitisedError.details.push(JSON.stringify(error));
    }
    return sanitisedError;
  }

}